(function(){
  'use strict';
  if (window.DSDPhase5ALiveReconciliation500) return;
  var scheduled = false;

  function all(selector, root){ try { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); } catch(e){ return []; } }
  function customer(){ return window.DSDShopifyCustomer || null; }
  function currentUser(){ return window.DSDLaunchSocial && window.DSDLaunchSocial.currentUser ? window.DSDLaunchSocial.currentUser() : {}; }

  function settleLoaders(){
    all('.is-loading,[aria-busy="true"],.loading-overlay,.loading__spinner,[data-loading]').forEach(function(node){
      if (node.closest('[data-dsd-composer-busy="true"]')) return;
      var media = node.querySelector && node.querySelector('img,video');
      var resolved = node.classList.contains('is-ready') || node.classList.contains('is-unavailable') || !media || (media.tagName === 'IMG' ? media.complete : media.readyState >= 1);
      if (!resolved) return;
      node.classList.remove('is-loading');
      node.removeAttribute('data-loading');
      if (node.getAttribute('aria-busy') === 'true') node.setAttribute('aria-busy','false');
    });
    all('.dsd-story385__tray-card span,.dsd-launch-muted,.dsd-mv395__empty').forEach(function(node){
      if (/^loading(?: previews| stories| profiles| feed| content)?\.?$/i.test(String(node.textContent || '').trim())) node.hidden = true;
    });
  }

  function enforcePublicActions(){
    if (customer()) return;
    all('[data-dsd-toggle-follow-profile],[data-dsd-follow-profile],[data-dsd-unfollow-profile],[data-dsd-favorite-user],[data-dsd-community-invite]').forEach(function(node){ node.remove(); });
    all('a[href^="/pages/messages"]').forEach(function(node){ node.remove(); });
  }

  function enforceProfileComposer(){
    if (!/\/pages\/user-profile(?:$|[/?#])/.test(location.pathname + location.search)) return;
    var key = new URL(location.href).searchParams.get('profile') || '';
    var user = currentUser();
    var own = !!(user.authenticated && (!key || key === user.profileKey));
    all('[data-dsd-profile-publisher],#dsd-composer-container,[data-dsd-story385-profile-action="create"]').forEach(function(node){
      node.hidden = !own;
      if ('disabled' in node) node.disabled = !own;
    });
  }

  function removeRetiredCommunityChat(){
    all('.dsd-mv395__chat,[data-dsd-mv-chat-form],[data-dsd-mv-chat-log]').forEach(function(node){ node.remove(); });
  }

  function cleanStoryStatus(){
    all('[data-dsd-story385-status],.dsd-story385__tray-card>span').forEach(function(node){
      if (/^(approved|pending)$/i.test(String(node.textContent || '').trim())) node.remove();
    });
  }

  function reconcile(){
    scheduled = false;
    settleLoaders();
    enforcePublicActions();
    enforceProfileComposer();
    removeRetiredCommunityChat();
    cleanStoryStatus();
    document.documentElement.classList.add('dsd-phase5a-reconciled');
  }

  function schedule(){ if (scheduled) return; scheduled = true; requestAnimationFrame(reconcile); }
  function boot(){
    reconcile();
    setTimeout(reconcile, 1800);
    setTimeout(reconcile, 6000);
    new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['class','aria-busy'] });
    window.addEventListener('dsd:launch-social:ready', schedule);
    window.addEventListener('load', schedule, { once:true });
  }

  window.DSDPhase5ALiveReconciliation500 = { version:'p11dz500-phase5a-live-reconciliation', reconcile:reconcile };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
})();
